import { Box, Divider, Paper, Typography, useMediaQuery, useTheme } from '@mui/material'
import Stack from '@mui/material/Stack'
import { Fragment, useCallback, useEffect, useRef, useState } from 'react'

import { useBookingContext } from '@providers/booking'
import { TBookingPet } from '@providers/booking/types'
import { MAX_WIDGET_SIZE } from '@shared/constants'
import { i18WithDefault as t } from '@shared/locale'
import { GroomingIcon, Spacer1, Spacer3 } from 'components-ui'
import { GroomingSelector } from './grooming_selector'
import { hasGroomBeenChosen } from './helper'
import { PreferredGroomer } from './preferred_groomer'
import { isUserLoggedIn } from '@providers/session/helpers'
import { useSessionContext } from '@providers/session'
import { Services } from 'service-api'
import { useParams } from 'react-router-dom'

export const Grooms = ({ currentTabIndex, showTitle = true }: { currentTabIndex: number; showTitle?: boolean }) => {
  const { accountName: locationName = '' } = useParams()
  const bookingCtx = useBookingContext()
  const sessionCtx = useSessionContext()
  const theme = useTheme()
  const isBelowMD = useMediaQuery(theme.breakpoints.down('md'))
  const hasFetchedResources = useRef(false)
  const currentSpecieId = bookingCtx.state.cart.groups[currentTabIndex].specieId ?? ''
  const showPreferredProvider = bookingCtx.state.data?.serviceType?.showPreferredProvider ?? false

  const [petsInGroup, setPetsInGroup] = useState<TBookingPet[]>([])

  const fetchResources = useCallback(async () => {
    const resources = await Services.ClientResourceService.list(locationName, {
      subtype: 'GROOMING_STAFF',
      type: 'PERSON',
    })

    if (resources?.results && resources?.results?.length) {
      bookingCtx.dispatch({ type: 'SET_RESOURCES', payload: { value: resources.results } })
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bookingCtx])

  useEffect(() => {
    const petsFromGroups: TBookingPet[] = []
    bookingCtx.state.cart.groups[currentTabIndex].pets?.map((pet): void => {
      if (!petsFromGroups.some((p) => p.id === pet.id)) petsFromGroups.push({ ...pet })
      setPetsInGroup(petsFromGroups)
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentTabIndex])

  useEffect(() => {
    if (isUserLoggedIn(sessionCtx.state.user) && !hasFetchedResources.current && showPreferredProvider) {
      fetchResources()
      hasFetchedResources.current = true
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showPreferredProvider])

  const searchResult = (bookingCtx.state.data.grooms ?? []).filter(
    (result) => result.offer?.locationSpecies?.id === currentSpecieId
  )

  const hasChosenAGroom = hasGroomBeenChosen(bookingCtx.state.cart)
  const hasResources = (bookingCtx.state.data?.resources?.length ?? 0) > 0

  const shouldShowPreferredGroomer = hasChosenAGroom && showPreferredProvider && hasResources

  return (
    <>
      {searchResult && searchResult.length !== 0 && (
        <>
          <Box sx={{ maxWidth: MAX_WIDGET_SIZE, margin: '0 auto' }}>
            <Paper elevation={1} sx={{ p: 2, borderRadius: `${isBelowMD ? 0 : theme.shape.borderRadius}px` }}>
              {showTitle && (
                <>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <GroomingIcon />
                    <Typography variant="h5">{t('searchPetAddOns.grooming')}</Typography>
                  </Stack>
                  <Spacer1 />
                  <Typography variant="body1">{t('searchPetAddOns.summary')}</Typography>
                  <Divider orientation="horizontal" sx={{ my: 2, maxWidth: '640px', marginX: 'auto' }} />
                </>
              )}

              {searchResult.map((o) => {
                return (
                  <Fragment key={o.offer!.id!}>
                    <GroomingSelector groom={o} groupIdx={currentTabIndex} petsInGroup={petsInGroup} />
                    <Divider orientation="horizontal" sx={{ my: 2, maxWidth: '640px', marginX: 'auto' }} />
                  </Fragment>
                )
              })}
              {shouldShowPreferredGroomer && isUserLoggedIn(sessionCtx.state.user) ? (
                <PreferredGroomer resources={bookingCtx.state.data.resources!} />
              ) : null}
              <Spacer3 />
            </Paper>
          </Box>
          <Spacer3 />
        </>
      )}
    </>
  )
}
